import { render, staticRenderFns } from "./DataFastSubscription.vue?vue&type=template&id=2c3c47e7&scoped=true"
import script from "./DataFastSubscription.vue?vue&type=script&lang=js"
export * from "./DataFastSubscription.vue?vue&type=script&lang=js"
import style0 from "./DataFastSubscription.vue?vue&type=style&index=0&id=2c3c47e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c47e7",
  null
  
)

export default component.exports